import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class ModuleService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getModulesList(page: number, pageSize: number = 10, filter: any): Observable<IPagedResults<any>> {
        let url = `Module/GetAll`;
        return super.getAll<any>(url);
    }

    public getModuleByTitle(title: string): Observable<any> {
        let url = `Module/GetByTitle?title=${title}`;
        return super.getAll<any>(url);
    }

    /*MODULE HELPER TEMPLATE*/

    public getModuleHelp(id: number) {
        let url = `ModuleHelp/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public getModuleHelpAll() {
        let url = `ModuleHelp/GetAll`;
        return super.getAll<any>(url);
    }

    public saveModuleHelp(data) {
        let url = `ModuleHelp/Save`;
        return super.save<any>(url, data);
    }

    public deleteModuleHelp(data) {
        let url = `ModuleHelp/Delete`;
        return super.save<any>(url, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/module.service.ts